/**
 * A single game seen from one side, for "highest score ever" style records.
 * `personId` is the record's holder; points are theirs, then their opponent's.
 */

import type { GameType } from "../history";
import type { PersonGame } from "../reportBuilder/ledger";

export interface GameRecord {
  season: number;
  week: number;
  gameType: GameType;
  personId: string;
  opponentId: string;
  points: number;
  opponentPoints: number;
}

export const toGameRecord = (g: PersonGame): GameRecord => ({
  season: g.season,
  week: g.week,
  gameType: g.gameType,
  personId: g.personId,
  opponentId: g.opponentId,
  points: g.points,
  opponentPoints: g.opponentPoints,
});

/**
 * The top `limit` items by `score`, highest first. The sort is stable, so
 * equal scores keep their input order: pass games oldest first and the
 * earliest one to set a mark ranks ahead of those that matched it.
 */
export function topBy<T>(items: readonly T[], score: (item: T) => number, limit: number): T[] {
  return [...items].sort((a, b) => score(b) - score(a)).slice(0, limit);
}
